// Zero-width provenance markers live in the knowledge-base prose fields.
// Every user-facing surface (pages, search, AI prompts, SEO output) must pass
// text through these helpers so the markers never reach a renderer or a model.
//
// Frontend code intentionally has no encoder — only the server can create markers.

const MARKER_CHARS = ['\u200B', '\u200C', '\u200D', '\u2060', '\uFEFF'];
const STRIP_RE = new RegExp(`[${MARKER_CHARS.join('')}]`, 'gu');

export function stripMarkers<T extends string | null | undefined>(text: T): T {
  if (typeof text !== 'string') return text;
  return text.replace(STRIP_RE, '') as T;
}

export function stripMarkersDeep<T>(value: T): T {
  if (typeof value === 'string') return stripMarkers(value) as unknown as T;
  if (Array.isArray(value)) return value.map((v) => stripMarkersDeep(v)) as unknown as T;
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[k] = stripMarkersDeep(v);
    }
    return out as unknown as T;
  }
  return value;
}
